import { createContext } from 'react';

const OrdersContext = createContext(null);

export { OrdersContext };
